<aside class="d-none d-md-block d-lg-block">
  <div class="container-aside">
    <div class="aside-header">
      <img src="../../../assets/svg/Logos.svg" class="LogoAside" alt="Sabemi" />
    </div>

    <div class="aside-content">
      <p class="TextoMioloSidebar">{{ messageBackground }}</p>
      <div class="EtapaSidebar mt-64">
        <h1>Etapas</h1>
        <h6>Contratação de Assistência Financeira</h6>
        <div class="mt-64"></div>
        <ul>
          <li>
            <div class="StatusEtapaOk">
              <mat-icon>done</mat-icon>
            </div>
            <a> Instituição pública </a>
          </li>
          <li>
            <div class="StatusEtapaOk">
              <mat-icon>done</mat-icon>
            </div>
            <a> Calculadora </a>
          </li>
          <li>
            <div class="StatusEtapaOk">
              <mat-icon>done</mat-icon>
            </div>
            <a> Resumo </a>
          </li>

          <li>
            <div
              [ngClass]="{
                StatusEtapaPendente: pendent.dados,
                StatusEtapaOk: !pendent.dados
              }"
            >
              <mat-icon>{{
                pendent.dados ? "query_builder" : "done"
              }}</mat-icon>
            </div>
            <a> Dados </a>
          </li>
          <li>
            <div
              [ngClass]="{
                StatusEtapaPendente: pendent.documentos,
                StatusEtapaOk: !pendent.documentos
              }"
            >
              <mat-icon>{{
                pendent.documentos ? "query_builder" : "done"
              }}</mat-icon>
            </div>
            <a> Documentação </a>
            <span *ngIf="pendent.qtyDocumentos"
              >Há {{ pendent.qtyDocumentos }} pendências</span
            >
          </li>

          <li>
            <div
              [ngClass]="{
                StatusEtapaPendente: pendent.contrato,
                StatusEtapaOk: !pendent.contrato
              }"
            >
              <mat-icon>{{
                pendent.contrato ? "query_builder" : "done"
              }}</mat-icon>
            </div>
            <a>Contrato</a>
          </li>

          <li>
            <div
              [ngClass]="{
                StatusEtapaPendente: pendent.foto,
                StatusEtapaOk: !pendent.foto
              }"
            >
              <mat-icon>{{ pendent.foto ? "query_builder" : "done" }}</mat-icon>
            </div>
            <a> Foto </a>
          </li>
        </ul>
        <div class="mb-64"></div>
      </div>
    </div>

    <div class="aside-footer">
      <img
        src="../../../assets/svg/ambiente-seguro.svg"
        class="AmbienteSeguro"
        alt="Ambiente Seguro"
      />
      <span class="AmbienteSeguroLabel">V 5.17.9</span>
    </div>
  </div>
</aside>
